<template>
  <main class="login">
    <div class="container-fluid">
      <div class="logo-wrapper">
        <img class="logo" src="../assets/img/common/logo.png" alt="Logo">
      </div>

      <div class="row">
        <div class="col col-12 col-sm-6 offset-sm-3">
          <b-form class="login-form" @submit="onSubmitLoginForm">
            <div class="login-fields">
              <b-form-input
                v-model="loginForm.username"
                class="form-control-custom"
                required
                placeholder="ชื่อผู้ใช้">
              </b-form-input>

              <b-form-input
                v-model="loginForm.password"
                class="form-control-custom"
                type="password"
                required
                placeholder="รหัสผ่าน">
              </b-form-input>
            </div>

            <div class="login-buttons">
              <button
                type="button"
                class="btn btn-custom-primary-outline btn-block btn-round"
                @click="onSubmitLoginForm">
                เข้าสู่ระบบ
              </button>


<!--              <div class="login-social">-->
<!--                <div class="social-button facebook" @click="socialFacebookLogin">-->
<!--                  <div class="button-addon" >-->
<!--                    <img src="../assets/img/common/fb.png" alt="facebook">-->
<!--                  </div>-->
<!--                  <div class="button-divider"></div>-->
<!--                  <div class="button-content">-->
<!--                                  <span>-->
<!--                                  เข้าสู่ระบบผ่าน facebook-->
<!--                                  </span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                  <div class="social-button google" @click="socialGoogleLogin">-->
<!--                    <div class="button-addon">-->
<!--                      <img src="../assets/img/common/google.png" alt="google">-->
<!--                    </div>-->
<!--                    <div class="button-divider"></div>-->
<!--                    <div class="button-content">-->
<!--                      <span>เข้าสู่ระบบผ่าน google</span>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                </div>-->

                <button
                  type="button"
                  class="btn btn-custom-primary btn-block btn-round"
                  @click="$router.push('/register')">
                  ลงทะเบียน
                </button>

                <div class="text-center">
                  <button type="button" class="btn text-custom-danger btn-link btn-forgot-password" @click="resetPasswordPage">
                    *ลืมรหัสผ่าน
                  </button>
                </div>

                <hr>
                <button
                  type="button"
                  class="btn btn-register btn-block btn-round"
                  @click="onGuestLoginForm">
                  เข้าใช้ทันที
                </button>
              </div>
          </b-form>
        </div>
      </div>
    </div>

    <hr>


  </main>
</template>
                <facebook-login style="padding-left: calc(50% - 110px)" ref="facebookLogin"  class="social-button facebook"
                                appId="2329806724005492"
                                loginLabel="เข้าสู่ระบบด้วย Facebook"
                                @login="getUserData"
                                @logout="onLogout"
                                @click="getUserData"
                                @sdk-loaded="sdkLoaded">

                  <div class="button-addon" >
                    <img src="../assets/img/common/fb.png" alt="facebook">
                  </div>
                  <div class="button-divider"></div>
                  <div class="button-content">
                  <span>
                  เข้าสู่ระบบผ่าน facebook
                  </span>
                  </div>
                </facebook-login>


<script>
  import Services from '../services'
  import {mapGetters, mapActions} from 'vuex'
  import facebookLogin from 'facebook-login-vuejs'
  import firebase from 'firebase'

  export default {
    name: 'login',
    components: {
      facebookLogin
    },
    data () {
      return {
        loginForm: {
          username: '',
          password: ''
        },
        loginGuestForm: {
          username: 'guest@mail.com',
          password: 'testtest123456*'
        },
        fbSignInParams: {
          scope: 'email,user_likes',
          return_scopes: true
        },
        FB: undefined,
        facebookData: {id: '',
          first_name: '',
          last_name: '',
          email: ''
        },
        googleData: {id: '',
          first_name: '',
          last_name: '',
          email: ''
        }
      }
    },
    computed: {
      ...mapGetters({token: 'User/getToken', user: 'User/getUser', facebookAccount: 'User/getFacebook', googleAccount: 'User/getGoogle'})
    },
    beforeMount () {
      this.setToken('')
      var urlParams = new URLSearchParams(location.search)
      if (urlParams.has('logout')) {
        this.facebookData = {
          id: '',
          first_name: '',
          last_name: '',
          email: ''
        }
        this.googleData = {
          id: '',
          first_name: '',
          last_name: '',
          email: ''
        }
        this.setFacebook(this.facebookData)
        this.setGoogle(this.googleData)
      }
      if (this.facebookAccount.id !== '') {
        this.facebookLogin()
      } else if (this.googleAccount.id !== '') {
        this.googleLogin()
      }
    },
    methods: {
      sdkLoaded (payload) {
        this.isConnected = payload.isConnected
        this.FB = payload.FB
        if (this.isConnected) this.getUserData()
      },
      getUserData () {
        this.FB.api('/me', 'GET', {fields: 'id,email,name'},
          userInformation => {
            console.log(userInformation)
            this.facebookData.id = userInformation.id
            this.facebookData.email = userInformation.email
            let res = userInformation.name.split(' ')
            console.log(res)
            this.facebookData.first_name = res[0]
            if (res.length > 1) {
              this.facebookData.last_name = res[1]
            } else {
              this.facebookData.last_name = ' '
            }
            console.log(this.facebookData)
            this.setFacebook(this.facebookData)
            this.facebookLogin()
          })
      },
      socialGoogleLogin () {
        const provide = new firebase.auth.GoogleAuthProvider().addScope('email')
        let self = this
        firebase
          .auth()
          .signInWithPopup(provide)
          .then(result => {
            // create user in db
            let obj = {
              google_id: result.additionalUserInfo.profile.id,
              fullname: result.additionalUserInfo.profile.name,
              email: result.additionalUserInfo.profile.email,
              profile_image: result.additionalUserInfo.profile.picture,
              user_type_id: 1
            }

            let res = obj.fullname.split(' ')
            console.log(res)
            self.googleData.id = obj.google_id
            self.googleData.email = obj.email
            self.googleData.first_name = res[0]
            if (res.length > 1) {
              self.googleData.last_name = res[1]
            } else {
              self.googleData.last_name = ' '
            }
            self.setGoogle(self.googleData)
            self.googleLogin()
            console.log(obj)
          })
          .catch(err => {
            alert('Oops. ' + err.message)
          })
      },
      socialFacebookLogin () {
        console.log('click facebook')
        const provide = new firebase.auth.FacebookAuthProvider().addScope('email')
        let self = this
        firebase
          .auth()
          .signInWithPopup(provide)
          .then(result => {
            // create user in db
            let obj = {
              facebook_id: result.additionalUserInfo.profile.id,
              fullname: result.additionalUserInfo.profile.name,
              email: result.additionalUserInfo.profile.email,
              profile_image: result.user.photoURL + '?height=500',
              user_type_id: 1
            }
            console.log(obj)

            let res = obj.fullname.split(' ')
            console.log(res)
            self.facebookData.id = obj.facebook_id
            self.facebookData.email = obj.email
            self.facebookData.first_name = res[0]
            if (res.length > 1) {
              self.facebookData.last_name = res[1]
            } else {
              self.facebookData.last_name = ' '
            }
            self.setFacebook(self.facebookData)
            self.facebookLogin()
          })
          .catch(err => {
            alert('Oopssss. ' + err.message)
          })
      },
      facebookLogin () {
        if (this.facebookAccount.id === '') {
          return
        }
        var self = this
        // eslint-disable-next-line no-undef
        NProgress.start()

        Services.auth.facebookLogin(this.facebookAccount).then(function (response) {
          // {"code":401,"status":"error","mes":"unauthorized.","error":"Your email\/password combination was incorrect"}
          if (response.status === 'success') {
            var token = response.result.access_token
            // console.log(token)
            self.setToken(token)
            Services.auth.getUserProfile(self.token).then(function (response) {
              // {"code":200,"status":"success","result":{"id":8850,"group_id":3,"active":1,"username":null,"email":"a22@gmail.com","first_name":"sra","last_name":"son","gender":"m","dob":"1988-10-07","avatar":null,"login_attempt":0,"last_login":"2019-05-22 01:01:35","created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 01:01:35","reminder":null,"activation":null,"last_activity":null,"config":null,"phone":null,"address":null,"citizen_id":"1111111111122","occupation":null,"province_code":"10","district_code":"false","amphoe_code":"1036","profile_educations":[{"id":18,"user_id":8850,"educational_institution":"ait","education_level":"\u0e42\u0e17","faculty":null,"sub_faculty":null,"grade":null,"start_at":"2019-05-22","end_at":null,"activities_societies":null,"explanation":null,"created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 00:33:56"}],"profile_experiences":[{"id":18,"user_id":8850,"position":"","working_at":"Kisra","start_at":"0000-00-00","end_at":null,"explanation":null,"created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 00:33:56"}]}}
              if (response.status === 'success') {
                var user = response.result
                console.log(user)
                self.setUser(user)
                self.$router.push('/')
              } else {
                self.alertX(response.error)
                console.log(response)
              }
            })
            // eslint-disable-next-line no-undef
            NProgress.done()
          } else {
            self.alertX(response.result.join())
            // eslint-disable-next-line no-undef
            NProgress.done()
          }
        }).catch(error => {
          console.log(error)
          let errObj = JSON.parse(JSON.stringify(error))
          this.alertX(errObj.response.data.error)
          // eslint-disable-next-line no-undef
          NProgress.done()
          // console.log(errObj.response.data.error)
        })
      },
      googleLogin () {
        if (this.googleAccount.id === '') {
          return
        }
        var self = this
        // eslint-disable-next-line no-undef
        NProgress.start()

        Services.auth.googleLogin(this.googleAccount).then(function (response) {
          // {"code":401,"status":"error","mes":"unauthorized.","error":"Your email\/password combination was incorrect"}
          if (response.status === 'success') {
            var token = response.result.access_token
            // console.log(token)
            self.setToken(token)
            Services.auth.getUserProfile(self.token).then(function (response) {
              // {"code":200,"status":"success","result":{"id":8850,"group_id":3,"active":1,"username":null,"email":"a22@gmail.com","first_name":"sra","last_name":"son","gender":"m","dob":"1988-10-07","avatar":null,"login_attempt":0,"last_login":"2019-05-22 01:01:35","created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 01:01:35","reminder":null,"activation":null,"last_activity":null,"config":null,"phone":null,"address":null,"citizen_id":"1111111111122","occupation":null,"province_code":"10","district_code":"false","amphoe_code":"1036","profile_educations":[{"id":18,"user_id":8850,"educational_institution":"ait","education_level":"\u0e42\u0e17","faculty":null,"sub_faculty":null,"grade":null,"start_at":"2019-05-22","end_at":null,"activities_societies":null,"explanation":null,"created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 00:33:56"}],"profile_experiences":[{"id":18,"user_id":8850,"position":"","working_at":"Kisra","start_at":"0000-00-00","end_at":null,"explanation":null,"created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 00:33:56"}]}}
              if (response.status === 'success') {
                var user = response.result
                console.log(user)
                self.setUser(user)
                self.$router.push('/')
              } else {
                self.alertX(response.error)
                console.log(response)
              }
            })
            // eslint-disable-next-line no-undef
            NProgress.done()
          } else {
            self.alertX(response.result.join())
            // eslint-disable-next-line no-undef
            NProgress.done()
          }
        }).catch(error => {
          console.log(error)
          let errObj = JSON.parse(JSON.stringify(error))
          this.alertX(errObj.response.data.error)
          // eslint-disable-next-line no-undef
          NProgress.done()
          // console.log(errObj.response.data.error)
        })
      },
      onLogout () {
        console.log('onLogout')
      },
      resetPasswordPage () {
        this.$router.push('/reset')
      },
      onSubmitLoginForm () {
        var self = this
        // eslint-disable-next-line no-undef
        NProgress.start()
        Services.auth.login(this.loginForm).then(function (response) {
          // {"code":401,"status":"error","mes":"unauthorized.","error":"Your email\/password combination was incorrect"}
          if (response.status === 'success') {
            var token = response.result.access_token
            // console.log(token)
            self.setToken(token)
            Services.auth.getUserProfile(self.token).then(function (response) {
              // {"code":200,"status":"success","result":{"id":8850,"group_id":3,"active":1,"username":null,"email":"a22@gmail.com","first_name":"sra","last_name":"son","gender":"m","dob":"1988-10-07","avatar":null,"login_attempt":0,"last_login":"2019-05-22 01:01:35","created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 01:01:35","reminder":null,"activation":null,"last_activity":null,"config":null,"phone":null,"address":null,"citizen_id":"1111111111122","occupation":null,"province_code":"10","district_code":"false","amphoe_code":"1036","profile_educations":[{"id":18,"user_id":8850,"educational_institution":"ait","education_level":"\u0e42\u0e17","faculty":null,"sub_faculty":null,"grade":null,"start_at":"2019-05-22","end_at":null,"activities_societies":null,"explanation":null,"created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 00:33:56"}],"profile_experiences":[{"id":18,"user_id":8850,"position":"","working_at":"Kisra","start_at":"0000-00-00","end_at":null,"explanation":null,"created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 00:33:56"}]}}
              if (response.status === 'success') {
                var user = response.result
                console.log(user)
                self.setUser(user)
                self.$router.push('/')
              } else {
                self.alertX(response.error)
                console.log(response)
              }
            })
            // eslint-disable-next-line no-undef
            NProgress.done()
          } else {
            self.alertX(response.result.join())
            // eslint-disable-next-line no-undef
            NProgress.done()
          }
        }).catch(error => {
          console.log(error)
          let errObj = JSON.parse(JSON.stringify(error))
          this.alertX(errObj.response.data.error)
          // eslint-disable-next-line no-undef
          NProgress.done()
          // console.log(errObj.response.data.error)
        })
      },
      alertX (message) {
        let options = {
          html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'ใช้',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'basic', // coming soon: 'soft', 'hard'
          verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
          verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
          clicksCount: 0, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: '' // Custom class to be injected into the parent node for the current dialog instance
        }
        this.$dialog.alert(message, options)
          .then(function (dialog) {
            console.log('Clicked on OK')
          })
          .catch(function () {
            console.log('Clicked on cancel')
          })
      },
      onGuestLoginForm () {
        var self = this
        // eslint-disable-next-line no-undef
        NProgress.start()
        Services.auth.login(this.loginGuestForm).then(function (response) {
          // {"code":401,"status":"error","mes":"unauthorized.","error":"Your email\/password combination was incorrect"}
          if (response.status === 'success') {
            var token = response.result.access_token
            console.log(token)
            self.setToken(token)
            Services.auth.getUserProfile(self.token).then(function (response) {
              // {"code":200,"status":"success","result":{"id":8850,"group_id":3,"active":1,"username":null,"email":"a22@gmail.com","first_name":"sra","last_name":"son","gender":"m","dob":"1988-10-07","avatar":null,"login_attempt":0,"last_login":"2019-05-22 01:01:35","created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 01:01:35","reminder":null,"activation":null,"last_activity":null,"config":null,"phone":null,"address":null,"citizen_id":"1111111111122","occupation":null,"province_code":"10","district_code":"false","amphoe_code":"1036","profile_educations":[{"id":18,"user_id":8850,"educational_institution":"ait","education_level":"\u0e42\u0e17","faculty":null,"sub_faculty":null,"grade":null,"start_at":"2019-05-22","end_at":null,"activities_societies":null,"explanation":null,"created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 00:33:56"}],"profile_experiences":[{"id":18,"user_id":8850,"position":"","working_at":"Kisra","start_at":"0000-00-00","end_at":null,"explanation":null,"created_at":"2019-05-22 00:33:56","updated_at":"2019-05-22 00:33:56"}]}}
              if (response.status === 'success') {
                var user = response.result
                console.log(user)
                self.setUser(user)
                self.$router.push('/')
              } else {
                this.alertX(response.error)
                console.log(response)
              }
            })
            // eslint-disable-next-line no-undef
            NProgress.done()
          } else {
            console.log(response)
            this.alertX(response.result.join())
            // eslint-disable-next-line no-undef
            NProgress.done()
          }
        }).catch(error => {
          console.log(error)
          let errObj = JSON.parse(JSON.stringify(error))
          this.alertX(errObj.response.data.error)
          // eslint-disable-next-line no-undef
          NProgress.done()
          // console.log(errObj.response.data.error)
        })
      },
      ...mapActions({setToken: 'User/setToken', setUser: 'User/setUser', setFacebook: 'User/setFacebook', setGoogle: 'User/setGoogle'})

    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  .facebook button{
    background-image: none !important;

  }

  main.login {
    padding: 40px 0;

    .fb-signin-button {
      /* This is where you control how the button looks. Be creative! */
      display: inline-block;
      padding: 4px 8px;
      border-radius: 3px;
      color: #fff;
    }

    .logo-wrapper {
      @extend .d-flex;
      margin-bottom: 20px;
      .logo {
        margin: auto;
      }
    }

    .login-form {
      .login-fields {
        margin-bottom: 0px;
        .form-control-custom {
          margin-bottom: 20px;
        }
      }

      .login-buttons {
        .btn {
          height: 50px;
          font-size: 18px;
        }
        .btn-register {
          color: $primary-color;
          background-color: $border-color;
          &:hover {
            color: $primary-color;
            background-color: darken($border-color, 5%);
          }
        }
        .btn-forgot-password {
          font-weight: 300;
          font-size: 14px;
        }
      }
    }

    .login-social {

      margin-top: 20px;

      .social-button {
        @extend .cursor-pointer;
        display: flex;
        height: 45px;
        align-items: stretch;
        color: white;
        margin-bottom: 15px;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        @include border-radius(9999px);
        .button-addon {
          @extend .d-flex;
          line-height: 45px;
          width: 60px;
          &>* {
            margin: auto;
          }
        }
        .button-divider {
          width: 1px;
          height: 100%;
          background-color: $border-color;
        }
        .button-content {
          @extend .d-flex;
          flex: 1;
          line-height: 45px;
          font-size: 18px;
          font-weight: 400;
          &>* {
            margin: auto;
          }
        }
        &.facebook {
          background-color: $fb-color;
          background-image: linear-gradient(#4C69BA, #3B55A0);
        }
        &.google {
          background-color: $google-color;
          &:hover {
            background-color: darken($google-color, 5%);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.page.vue